/**
 * Retrieves a configuration variable from the runtime environment (Docker),
 * falling back to a default value (usually process.env) if missing.
 */
export const getRuntimeVar = (key, fallback = '') => {
  // 1. Try to read from the browser's window object
  const runtimeValue = window._env_ && window._env_[key];

  // 2. If it exists and isn't empty, return it
  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
    return runtimeValue;
  }

  // 3. Otherwise, return the fallback
  return fallback;
};
